/**
 * @desc 创建变更需求
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ChangeOrderCreateDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
